module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "x1toc",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_vm._v("contents"), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  })]), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }, [_c('div', {
    staticClass: "ding"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "264.png",
      "src": "image/264.png"
    }
  })])]), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }), _c('a', {
    attrs: {
      "href": "#/SPE#Anchor-8"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE1#Anchor"
    }
  }, [_vm._v("Part I")]), _vm._v(": foundation"), _c('br'), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("Discovering the Gift of Empathy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE2#Anchor-9"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Your Empathic Gifts: The Clairs")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE3#Anchor-10"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Your Empathic Body: Wired to Connect")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE4#Anchor-11"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Compassion: The Lining of the Empath’s Soul")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE5#Anchor-12"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Learn Your Type: The Six Empathic Styles")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE6#Anchor-13"
    }
  }, [_vm._v("Part II")]), _vm._v(": application"), _c('br'), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("Mastering the Gift of Empathy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE7#Anchor-14"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Tools for Compassionate Empathy")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE8#Anchor-15"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Empathic Healing: How Empaths"), _c('br'), _vm._v("Can Heal Themselves and Others")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE9#Anchor-16"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The Empath in Relationships")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE10#Anchor-17"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Empathy and Your Vocation:"), _c('br'), _vm._v("The Calling to Care")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE11#Anchor-18"
    }
  }, [_c('span', {
    staticClass: "sc char-style-override-2"
  }, [_vm._v("Conclusion")])]), _vm._v(" Embrace Your Gifts: The Joy of Empathy")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE12#Anchor-19"
    }
  }, [_c('span', {
    staticClass: "sc char-style-override-2"
  }, [_vm._v("Appendix 1")])]), _vm._v(" Sympathy (and Other Empathy Impostors)")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE13#Anchor-20"
    }
  }, [_c('span', {
    staticClass: "sc char-style-override-2"
  }, [_vm._v("Appendix 2")])]), _vm._v(" Impaired Empaths")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE14#Anchor-21"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE15#Anchor-22"
    }
  }, [_vm._v("Resource Recommendations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE16#Anchor-23"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part"
  }, [_vm._v("Empathic Explorations")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE2#Look-to-Your-Own-Experience"
    }
  }, [_vm._v("Look to Your Own Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE3#What-Do-You-Feel-in-Your-Body"
    }
  }, [_vm._v("What Do You Feel in Your Body")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE4#What-Isn-t-Empathy"
    }
  }, [_vm._v("What Isn’t Empathy")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SPE5#What-is-Your-Style"
    }
  }, [_vm._v("What is Your Style")]), _vm._v("? ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0